<template>
	<div class="Profile_view">
		<ProfileMenuMobile :header="$t('profile.subHeaderText')" />
		<div class="grid-container">
			<div class="grid-x grid-margin-y grid-margin-x hide-for-small-only">
				<div class="cell small-12 medium-6">
					<ProfileHeader :subTitle="$t('profile.subHeaderText')" />
				</div>
				<div class="cell small-12 medium-6 Profile_view--right">
					<Button size="small" color="dark" @click.native="logout">
						{{ $t('profile.logoutButton') }}
					</Button>
				</div>
			</div>
			<div class="grid-x grid-margin-x">
				<div class="cell small-12 medium-4 large-4">
					<ProfileMenu />
				</div>
				<!-- <transition name="fade-slide" mode="out-in"> -->
				<router-view></router-view>
				<!-- </transition> -->
				<div class="cell small-12 medium-6 Profile_view--bottom">
					<Button :full="true" size="small" color="dark" @click.native="logout">
						{{ $t('profile.logoutButton') }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import ProfileHeader from '../../components/molecules/ProfileHeader'
import ProfileMenu from '../../components/molecules/ProfileMenu'
import ProfileMenuMobile from '../../components/molecules/ProfileMenuMobile'
import Button from '../../components/atoms/Button'

export default {
	name: 'Profile_view',
	data() {
		return {}
	},
	components: {
		ProfileHeader,
		ProfileMenu,
		ProfileMenuMobile,
		Button
	},
	methods: {
		logout() {
			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(() => {
				store
					.dispatch('DELETE_TOKEN', { token: store.state.token.refreshToken })
					.then(() => {
						this.$router.push({ name: 'login' })
					})
			})
		}
	}
}
</script>

<style lang="scss">
// .fade-enter-active, .fade-leave-active {
// 	transition: all .2s ease-in-out;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
// 	transform: translate(10%, 0);
// 	opacity: 0;
// }
.Profile_view {
	overflow: hidden;
	@include profile-background;
	&--right {
		display: flex;
		justify-content: flex-end;
		padding-top: 10px;
	}
	&--bottom {
		padding: 40px 0;
		@include for-tablet-portrait-up {
			display: none;
		}
	}

	&__actions {
		display: flex;
		flex-direction: column;
		margin-top: 50px;

		> * {
			width: 100%;
			margin-top: 20px;

			&:first-child {
				margin-top: 0;
			}
		}

		a > button {
			width: 100%;
		}

		&--small {
			margin-top: 20px;
		}
	}

	@media only screen and (min-width: 380px) {
		&__actions {
			flex-direction: row;

			> * {
				width: auto;
				margin-top: 0;
				margin-left: 20px;

				&:first-child {
					margin-left: 0;
				}

				a {
					width: auto;
				}
			}
		}
	}
}
</style>
